export default __webpack_public_path__ + "static/media/Artboard 8.13501800.png";